import React, { useState, useEffect, useCallback, useRef } from 'react';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { api, ProductTagEnum } from 'api';
import pick from 'lodash/pick';
import lGet from 'lodash/get';
import moment from 'moment';
import SchduleForm from './ScheduleForm';
import { MeetingRoomForm } from './MeetingRoomForm';
import DayViewTimeLineGrid from '../DayViewTimeLineGrid/DayViewTimeLineGrid';
import useForceUpdate from '../../forceUpdate';
import { checkMeettingRoomExsit, getMeetingRoomAvailabelList, getMeetingRoomReserveConfig } from '../../service';
import Alert from '@web-common/components/UI/Alert/Alert';
import { ScheduleActions, useActions, useAppSelector } from '@web-common/state/createStore';
import { constructAvailableMeetingRoomParam, getContanctObjs, handleMeetingFormTimeRangeNew, reminderOpts, serializeFormMoments, } from './util';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import ProductAuthTag from '@web-common/components/UI/ProductAuthTag/ProductAuthTag';
import { ScheduleSyncObInitiator } from '../../data';
import styles from './eventBody.module.scss';
import { getIn18Text } from 'api';
const sysApi = api.getSystemApi();
const eventApi = api.getEventApi();
const EventBody = ({ onCancel, selectDate, subWindow = false, initValues, defaultContactList, defaultMoreInvitee, defaultexpanded = false, onSyncCancel, defaultMeetingTipType, defaultLoopRRules, onTimeRelatedValuesChange, source = ScheduleSyncObInitiator.MAIN_MODULE, initFormChangedMaunal = false, belongIdStr = '', }, ref) => {
    var _a, _b, _c, _d, _e, _f;
    const [selectingMeetingRoom, setSelectingMeetingRoom] = useState(false);
    const [meetingRoomChanged, setMeetingRoomChanged] = useState(0);
    const [meetingRoomExsit, setMeetingRoomExsit] = useState(false);
    const [reserveConfig, setReserveConfig] = useState(undefined);
    const [selectedAddr, setSelectedAddr] = useState('');
    const [expanded, setExpanded] = useState(subWindow || defaultexpanded);
    const { catalogList, scheduleEvent, unSelectedCatalogIds, scheduleEditFrom, lastSelectTimezone, showSecondaryZone, settingZoneList } = useAppSelector(state => state.scheduleReducer);
    const actions = useActions(ScheduleActions);
    const formRef = useRef(null);
    const forceUpdate = useForceUpdate();
    const [formChangedMaunal, setFormChangedMaunal] = useState(initFormChangedMaunal);
    const handleFormChange = changedValues => {
        var _a;
        setFormChangedMaunal(true);
        forceUpdate();
        getMeetingRoom();
        const location = ((_a = changedValues === null || changedValues === void 0 ? void 0 : changedValues.location) === null || _a === void 0 ? void 0 : _a.trim()) || '';
        if (location) {
            matchMeetingRoom(location);
        }
    };
    const [roomMatchList, setRoomMatchList] = useState([]);
    const getMeetingRoom = () => {
        var _a;
        constructAvailableMeetingRoomParam((_a = formRef.current) === null || _a === void 0 ? void 0 : _a.getFormInstance().getFieldsValue(), scheduleEvent).then(condition => {
            if (condition) {
                getMeetingRoomAvailabelList(condition)
                    .then(setRoomMatchList)
                    .catch(() => setRoomMatchList([]));
            }
        });
    };
    const matchMeetingRoom = async (location) => {
        var _a, _b, _c;
        if (roomMatchList && roomMatchList.length && !!location) {
            const info = roomMatchList.find(room => { var _a; return ((_a = room === null || room === void 0 ? void 0 : room.roomInfo) === null || _a === void 0 ? void 0 : _a.name) === location; });
            const values = (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.getFormInstance().getFieldsValue();
            if (info && values) {
                const { formStartDate, formEndDate, formStartTime, formEndTime, originStart, originEnd } = await handleMeetingFormTimeRangeNew(Object.assign(Object.assign({}, values.moments), { allDay: !!values.time.allDay, zoneId: values.zoneId }));
                const { roomInfo: { name, addr_name, room_id }, } = info;
                (_c = (_b = formRef.current) === null || _b === void 0 ? void 0 : _b.getFormInstance()) === null || _c === void 0 ? void 0 : _c.setFieldsValue({
                    location: [name, addr_name].filter(e => !!e).join('，'),
                    moments: {
                        startDate: formStartDate.clone(),
                        endDate: formEndDate.clone(),
                        startTime: formStartTime.clone(),
                        endTime: formEndTime.clone(),
                    },
                    meetingOrderParam: {
                        update_type: 1,
                        room_id,
                        taken_date: formStartDate.format('YYYY-MM-DD'),
                    },
                });
                setTimeout(() => { var _a, _b; return (_b = (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.recomputeDurationError) === null || _b === void 0 ? void 0 : _b.call(_a); }, 0);
                setMeetingRoomChanged(state => state + 1);
                if (!((originStart === null || originStart === void 0 ? void 0 : originStart.y) === (originEnd === null || originEnd === void 0 ? void 0 : originEnd.y) && (originStart === null || originStart === void 0 ? void 0 : originStart.m) === (originEnd === null || originEnd === void 0 ? void 0 : originEnd.m) && (originStart === null || originStart === void 0 ? void 0 : originStart.d) === (originEnd === null || originEnd === void 0 ? void 0 : originEnd.d))) {
                    SiriusMessage.info({
                        content: getIn18Text('crossScheduleMeetingRoomTip'),
                    });
                }
            }
        }
    };
    const handleExpanded = async (b) => {
        var _a, _b, _c, _d, _e;
        if (sysApi.isElectron() && !subWindow) {
            const initData = {
                settingZoneList,
                lastSelectTimezone,
                showSecondaryZone,
                formChangedMaunal,
                unSelectedCatalogIds,
                catalogList,
                event: scheduleEvent,
                defaultMeetingTipType: (_b = (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.getMeetingTipType) === null || _b === void 0 ? void 0 : _b.call(_a),
                defaultLoopRRules: (_d = (_c = formRef.current) === null || _c === void 0 ? void 0 : _c.getLoopRRules) === null || _d === void 0 ? void 0 : _d.call(_c),
                formValues: serializeFormMoments((_e = formRef.current) === null || _e === void 0 ? void 0 : _e.getFormInstance().getFieldsValue()),
            };
            if (selectDate) {
                initData.selectDate = Object.assign({}, pick(selectDate, ['start', 'end', 'allDay', 'view.type']));
            }
            if (Array.isArray(initData.formValues.required)) {
                initData.defaultContactList = await getContanctObjs(initData.formValues.required);
            }
            if (Array.isArray(initData.formValues.moreInvitee)) {
                initData.defaultMoreInvitees = await getContanctObjs(initData.formValues.moreInvitee);
            }
            if (Array.isArray(initData.formValues.enmuReminders) && initData.formValues.enmuReminders.length === 0) {
                initData.formValues.enmuReminders = [reminderOpts(lGet(initData.formValues, ['time', 'allDay']))[0].value];
            }
            if (scheduleEditFrom) {
                initData.scheduleEditFrom = scheduleEditFrom;
            }
            sysApi.createWindowWithInitData('scheduleOpPage', { eventName: 'initPage', eventData: initData });
            onCancel && onCancel();
        }
        else {
            setExpanded(b);
        }
    };
    const handleCancel = useCallback(() => {
        if (!onCancel) {
            return;
        }
        if (formChangedMaunal) {
            const al = Alert.error({
                cancelText: getIn18Text('JIXUBIANJI'),
                okText: getIn18Text('QUEDINGTUICHU'),
                okCancel: !0,
                content: getIn18Text('RICHENGWEIBAOCUN'),
                okType: 'danger',
                onOk: () => {
                    al.destroy();
                    onCancel();
                },
                maskStyle: { left: 0 },
            });
        }
        else {
            onCancel();
        }
    }, [formChangedMaunal, onCancel]);
    const syncSchedule = async (action, msg) => {
        var _a;
        if (sysApi.isElectron() && subWindow) {
            const startDate = (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.getFormInstance().getFieldValue(['moments', 'startDate']);
            await eventApi.sendSysEvent({
                eventName: 'syncSchedule',
                eventData: {
                    msg,
                    startDate: moment.isMoment(startDate) ? startDate.valueOf() : null,
                },
                eventStrData: source,
            });
        }
        else {
            msg && SiriusMessage.success({ content: msg });
            actions.syncSchedule(action);
        }
    };
    const expandedElRef = useRef(null);
    useEffect(() => {
        if (expanded) {
            if (expandedElRef && expandedElRef.current && expandedElRef.current.getBoundingClientRect) {
                const rect = expandedElRef.current.getBoundingClientRect();
                if (rect) {
                    expandedElRef.current.style.height = rect.height + 'px';
                }
            }
        }
    }, [expanded]);
    const handleAfterSubmit = async (action, msg) => {
        onSyncCancel && onSyncCancel();
        await syncSchedule(action, msg);
        onCancel && onCancel(action, msg);
    };
    React.useImperativeHandle(ref, () => ({
        triggerCancel: () => {
            handleCancel();
        },
        setFormValues: (values) => {
            var _a;
            (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.getFormInstance().setFieldsValue(values);
        },
    }), [handleCancel]);
    useEffect(() => {
        checkMeettingRoomExsit().then(setMeetingRoomExsit);
    }, []);
    useEffect(() => {
        getMeetingRoomReserveConfig()
            .then(setReserveConfig)
            .catch(() => setReserveConfig(undefined));
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(OverlayScrollbarsComponent, { style: { display: selectingMeetingRoom ? 'none' : 'block', height: '100%' } },
            React.createElement("div", { style: {
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    minHeight: 392,
                }, className: "ant-allow-dark dark-white-bg" },
                React.createElement("div", { style: { width: subWindow ? 580 : 580, flexShrink: 0 } },
                    React.createElement(ProductAuthTag, { type: "bar", tagName: [ProductTagEnum.MEETING_SETTING, ProductTagEnum.SCHEDULE_SETTING], tipText: getIn18Text('HUIYISHI/RI') }),
                    React.createElement(SchduleForm, { formChangedMaunal: formChangedMaunal, onTimeRelatedValuesChange: onTimeRelatedValuesChange, defaultLoopRRules: defaultLoopRRules, defaultMeetingTipType: defaultMeetingTipType, defaultContactList: defaultContactList, defaultMoreInvitee: defaultMoreInvitee, initValues: initValues, style: subWindow ? undefined : { maxHeight: 440 }, onAfterSubmit: handleAfterSubmit, onGoSelectMeetingRoom: () => setSelectingMeetingRoom(true), ref: formRef, meetingRoomExsit: meetingRoomExsit, reserveConfig: reserveConfig, onChange: handleFormChange, onCancel: handleCancel, selectDate: selectDate, onExpand: handleExpanded, expanded: expanded, selectingMeetingRoom: selectingMeetingRoom, meetingRoomChanged: meetingRoomChanged, belongIdStr: belongIdStr })),
                expanded && (React.createElement("div", { style: {
                        flexShrink: 0,
                        flexGrow: 1,
                        minWidth: 380,
                    }, ref: expandedElRef, className: styles.dayViewWrap },
                    React.createElement(DayViewTimeLineGrid, { startDate: (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.getFormInstance().getFieldValue(['moments', 'startDate']), endDate: (_b = formRef.current) === null || _b === void 0 ? void 0 : _b.getFormInstance().getFieldValue(['moments', 'endDate']), startTime: (_c = formRef.current) === null || _c === void 0 ? void 0 : _c.getFormInstance().getFieldValue(['moments', 'startTime']), endTime: (_d = formRef.current) === null || _d === void 0 ? void 0 : _d.getFormInstance().getFieldValue(['moments', 'endTime']), allDay: (_e = formRef.current) === null || _e === void 0 ? void 0 : _e.getFormInstance().getFieldValue(['time', 'allDay']), users: (_f = formRef.current) === null || _f === void 0 ? void 0 : _f.getFormInstance().getFieldValue('required') }))))),
        selectingMeetingRoom && meetingRoomExsit && (React.createElement(MeetingRoomForm, { style: {
                height: subWindow ? 'calc(100% - 32px)' : 542,
                width: subWindow ? '100%' : 680,
            }, onNavigate: () => {
                onCancel && onCancel();
            }, onSelectAddr: setSelectedAddr, defaultSelectedAddr: selectedAddr, onBack: ok => {
                if (ok) {
                    setFormChangedMaunal(ok);
                }
                setSelectingMeetingRoom(false);
            }, scheduleFormRef: formRef.current, reserveConfig: reserveConfig }))));
};
export default React.forwardRef(EventBody);
